import React from "react";
import { Row } from "antd";
import GalleryUploader from "../../components/General/GalleryUploader";
import GalleryDisplay from "../General/GalleryDisplay";

const Gallery = ({ state = {}, aspect, readOnly, width = "20rem", MAX, ...props }) => {
  const { data, onChange } = state;

  return readOnly ? (
    <GalleryDisplay gallery={data} width={width} {...props} />
  ) : (
    <GalleryUploader
      gallery={data}
      aspect={aspect}
      MAX={MAX}
      style={{ width: width }}
      onFinish={(url) => {
        console.log(url);
        onChange({ gallery: [...(data || []), url] });
      }}
      onDelete={(i) => {
        onChange({ gallery: data.filter((_, index) => index !== i) });
      }}
      onMove={(direction, i) => {
        const updatedGallery = [...data];
        console.log(updatedGallery);

        if (direction === "up" && i > 0) {
          [updatedGallery[i], updatedGallery[i - 1]] = [updatedGallery[i - 1], updatedGallery[i]];
        } else if (direction === "down" && i < updatedGallery.length - 1) {
          [updatedGallery[i], updatedGallery[i + 1]] = [updatedGallery[i + 1], updatedGallery[i]];
        }

        console.log(updatedGallery);
        onChange({ gallery: updatedGallery });
      }}
    />
  );
};

export default Gallery;
